import * as React from 'react';

type SidePanelState = {
    [key: string]: boolean;
};

const SidePanelContext = React.createContext<{
    sidePanelState: SidePanelState;
    openPanel: (panelName: string) => void;
    closePanel: (panelName: string) => void;
    setForceSidePanel: React.Dispatch<React.SetStateAction<boolean>>;
    forceSidePanel: boolean;
    forceLeftStaticPanel: boolean;
    setForceLeftStaticPanel: React.Dispatch<React.SetStateAction<boolean>>;
} | null>(null);

export const useSidePanel = () => {
    const context = React.useContext(SidePanelContext);

    if (!context) {
        throw new Error('useSidePanel must be used within a SidePanelProvider');
    }

    return context;
};

const SidePanelContextProvider = ({ children }: { children: React.ReactNode }) => {
    const [sidePanelState, setSidePanelState] = React.useState<SidePanelState>({});
    const [forceSidePanel, setForceSidePanel] = React.useState<boolean>(false);
    const [forceLeftStaticPanel, setForceLeftStaticPanel] = React.useState<boolean>(false);

    const openPanel = (panelName: string) => {
        // Skip if the panel is already open
        if (sidePanelState[panelName]) {
            return;
        }
        setSidePanelState((prevState) => ({ ...prevState, [panelName]: true }));
    };

    const closePanel = (panelName: string) => {
        setSidePanelState((prevState) => ({ ...prevState, [panelName]: false }));
    };

    return (
        <SidePanelContext.Provider
            value={{
                sidePanelState,
                openPanel,
                closePanel,
                setForceSidePanel,
                forceSidePanel,
                forceLeftStaticPanel,
                setForceLeftStaticPanel,
            }}
        >
            {children}
        </SidePanelContext.Provider>
    );
};

export { SidePanelContext, SidePanelContextProvider };
